import actions from "@/store/modules/gameKiller/actions";
import getters from "@/store/modules/gameKiller/getters";
import mutations from "@/store/modules/gameKiller/mutations";

const state = {
    data: null,
    timerVote: 0,
    timerReport: 0,
    timerKiller: 0,
    timerBan: 0,
    userVoted: false,
    lastDead: null,
};

export type State = typeof state;

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};